import Auth from '@/vuex/auth/module'
import UI from '@/vuex/ui/module'
import CaixaPostal from '@/vuex/caixa-postal/module'
import BuscaDocumentos from '@/vuex/busca-documentos/module'
import Documento from '@/vuex/documento/module'
import Juntada from '@/vuex/juntada/module'
import Tramitacoes from '@/vuex/tramitacoes/module'
import Autuacao from '@/vuex/autuacao/module'
import ArquivosDocumento from '@/vuex/arquivos-documento/module'
import VinculosDocumento from '@/vuex/vinculos-documento/module'
import Relatorios from '@/vuex/relatorios/module'
import Administracao from '@/vuex/administracao/module'
import ReencaminhamentoDocumento from '@/vuex/reencaminhamento-documento/module'
import DocumentosFavoritos from '@/vuex/documentos-favoritos/module'
import EdicaoTipoDocumental from '@/vuex/administracao/edicao-tipo-documental/module'
import ArquivosAssinados from '@/vuex/arquivos-assinados/module'

import Vue from 'vue'

// Vuex for state management
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
  modules: {
    'auth': Auth,
    'ui': UI,
    'caixaPostal': CaixaPostal,
    'buscaDocumentos': BuscaDocumentos,
    'documento': Documento,
    'juntada': Juntada,
    'tramitacoes': Tramitacoes,
    'autuacao': Autuacao,
    'arquivosDocumento': ArquivosDocumento,
    'vinculosDocumento': VinculosDocumento,
    'relatorios': Relatorios,
    'administracao': Administracao,
    'reencaminhamento-documento': ReencaminhamentoDocumento,
    'documentosFavoritos': DocumentosFavoritos,
    'edicaoTipoDocumental': EdicaoTipoDocumental,
    'arquivosAssinados': ArquivosAssinados
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js